import React, { useState, useEffect } from 'react';
import Promotion from './components/promotion/promotion.component';
import TypeformComponent from './components/typeform/typeform.component';
import Plan from './components/plans/plan.component';
import { fetchPlans, addCartProduct, updateKlaviyoProfile, sendSignupToZapier, sendSignUpEvent } from './services/api';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PaymentForm from './components/paymentForm/paymentForm.component';
import styles from './App.module.scss';
import * as Sentry from '@sentry/react';
import FullLoader from './components/fullLoader/fullLoader.component';
import { useHistory, useLocation } from 'react-router-dom';
import './App.module.scss';
import { get_cookie, set_cookie } from './helper';
import Checkmark from './components/icons/Checkmark';
import { useIntercom } from 'react-use-intercom';
import ThinkingSection from './components/thinking/thinking';

const stripePromise = loadStripe(window.checkoutConfig.stripe_key);

function App() {
  const history = useHistory();
  const location = useLocation();

 // const steps = ["quiz", "email", "thinking", "start-cooking", "plans", "checkout"];
  const steps = ["quiz", "email", "start-cooking", "plans", "checkout"];

  function getNextStep(currentId) {
    const index = steps.indexOf(currentId);
    if (index === -1 || index === steps.length - 1) {
      return null; // Not found or already at the last step
    }
    return steps[index + 1];
  }

  const { boot, shutdown } = useIntercom();

  const url = new URL(window.location.href);
  const stepParam = url.searchParams.get('step');

  const [page, setPage] = useState(stepParam ?? 'quiz');
  const [emailFetched, setEmailFetched] = useState(false);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [processingOrder, setProcessingOrder] = useState(false);
  const [scrollTo, setScrollTo] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPlanSku, setSelectedPlanSku] = useState("yc_annual-c3z-b");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [currencySymbol, setCurrencySymbol] = useState('');
  const [cart, setCart] = useState(null);
  const [initCart, setInitCart] = useState(false);
  const [specialOffer, setSpecialOffer] = useState(null);
  const [signupTriggered, setSignupTriggered] = useState(false);
  const [userSubExists, setUserSubExists] = useState(false);

  const appearanceOptions = {
    theme: 'none', // Fully customize the appearance
    variables: {
      fontFamily: 'Open Sans, sans-serif',
      fontSizeBase: '16px',
      borderRadius: '4px',
      colorText: '#2e2e2e',
      spacingUnit: '8px',
      spacingGridRow: '8px', // Override the spacingGridRow variable
      spacingGridColumn: '8px',
    },
    rules: {
      '.Input': {
        background: '#fff',
        border: 'none',
        borderRadius: '4px',
        color: '#2e2e2e',
        fontSize: '16px',
        fontWeight: '600',
        padding: '8px',
        height: '39px',
        lineHeight: '39px',
      },
      '.Input--invalid': {
        borderColor: '#e5424d',
      },
      '.Label': {
        fontSize: '0px',
        margin: '0px'
      },
      '.p-GridCell': {
        marginBottom: '16px !important', // Force the marginBottom
        paddingLeft: '0 !important',     // Reset paddingLeft to 0
      },
    },
  };

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(null);
  let validateTimeout;

  const [elementOptions, setElementOptions] = useState({
    mode: 'payment',
    amount: 10,
    currency: 'usd',
    paymentMethodCreation: 'manual',
    fonts: [
      {
        cssSrc:
          'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap'
      }
    ],
    appearance: appearanceOptions, // Include the appearance object here
  });

  const updateElementOptions = (amount, currency) => {
    setElementOptions({
      mode: 'payment',
      amount: amount,
      currency: currency.toLowerCase(),
      paymentMethodCreation: 'manual',
      fonts: [
        {
          cssSrc:
            'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap'
        }
      ],
      appearance: appearanceOptions, // Include the appearance object here
    });
  };


  // Data for promotional components
  const promotions = [
    {
      id: 1,
      image: '/wp-content/reactpress/apps/yc-checkout/build/assets/promotion1.webp',
      header: 'Get inspired',
      description: 'Travel the world from home to discover the stories of each chef, their food, and their country.'
    },
    {
      id: 2,
      image: '/wp-content/reactpress/apps/yc-checkout/build/assets/promotion2.webp',
      header: 'Learn from the best',
      description: 'Gain the culinary knowledge, techniques, and secrets of the world’s most meaningful chefs.'
    },
    {
      id: 3,
      image: '/wp-content/reactpress/apps/yc-checkout/build/assets/promotion3.webp',
      header: 'Cook delicious',
      description: 'Share your love through food, with hundreds of dishes and flavors from around the world.'
    }
  ];


  const addToCart = (product_id) => {
    // setLoading(true);
    setShowSkeleton(true);
    addCartProduct(product_id, 1)
      .then(data => {
        setCart(data);

      })
      .catch(error => {
        Sentry.captureException(error);
        // console.error('Failed to add to cart:', error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
        setShowSkeleton(false);
        if (!initCart) setInitCart(true);

        if (!scrollTo) {
          if (window.location.href.indexOf("#membership") > -1) {
            var membershipSection = document.getElementById('membership');
            if (membershipSection) {
              membershipSection.scrollIntoView({ behavior: 'smooth' });
              setScrollTo(true);
            }
          }
        }
      });
  }

  const selectPlan = (plan) => {
    setSelectedPlanSku(plan.product_id);
    setSelectedPlan(plan);

    localStorage.setItem('selected_plan', JSON.stringify(plan));
    let amount;
    if (plan.discounted_price !== null && typeof plan.discounted_price !== 'undefined' && Number(plan.discounted_price) !== 0) {
      amount = Number(plan.discounted_price) * 100;
    } else {
      amount = Number(plan.price) * 100;
    }
    amount = Math.round(amount);
    updateElementOptions(amount, plan.currency.toLowerCase());
    // getCart(plan.product_id);
    addToCart(plan.product_id)
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const currentStep = queryParams.get('step') ?? 'quiz';

    // Set checkout path cookie 
    set_cookie('checkout_path', '/memberships')

    // If plans visited go to step 4
    const plansVisited = JSON.parse(localStorage.getItem('plans_visited'));
    if (plansVisited === true && currentStep && ['quiz', 'email', 'start-cooking'].includes(currentStep)) {
      history.push({ search: '?step=plans' });
    }

    // If form submitted, go to step 2
    const formSubmitted = localStorage.getItem('form_submitted') === 'true' && localStorage.getItem('tf_submit') === '1';
    if (formSubmitted === true && currentStep && ['quiz'].includes(currentStep)) {
      history.push({ search: '?step=email' });
    }

    // Set special offer text
    setSpecialOffer(window.checkoutConfig?.offer_text);
    // Check if the URL contains #membership
    const url_sku = queryParams.get('product_sku');

    fetchPlans()
      .then((plans) => {
        plans = plans.sort((a, b) => {
          const getSortValue = (plan) => {
            if (plan.subscription_period === "lifetime") return 3; // Highest priority
            if (plan.duration_months === 12) return 2; // Second priority
            if (plan.duration_months === 3) return 1;  // Lowest priority
            return 0; // Default
          };
        
          return getSortValue(b) - getSortValue(a);
        });
        console.log("plans",plans);

        setPlans(plans);
        setCurrencySymbol(plans[0].currency_symbol);

        let selected_plan;

        // Check if url has plan
        if (url_sku) {
          selected_plan = plans.find(plan => plan.product_sku === url_sku);
        }

        if(!selected_plan) {
          // Check if local storage has plan
          let stored_plan = localStorage.getItem('selected_plan');
          if (stored_plan) {
            stored_plan = JSON.parse(stored_plan);
            selected_plan = plans.find(plan => plan.product_id === stored_plan.product_id);
          }
        }

        // If no matching plan found, default to annual subscription
        if (!selected_plan) {
          selected_plan = plans.find(plan => plan.subscription_period === 'annual');
        }

        if (selected_plan) {
          setSelectedPlanSku(selected_plan.product_id);
          setSelectedPlan(selected_plan);
          // getCart();
          addToCart(selected_plan.product_id);
          let amount;
          if (selected_plan.discounted_price !== null && typeof selected_plan.discounted_price !== 'undefined' && Number(selected_plan.discounted_price) !== 0) {
            amount = Number(selected_plan.discounted_price) * 100;
          } else {
            amount = Number(selected_plan.price) * 100;
          }
          amount = Math.round(amount);
          updateElementOptions(amount, selected_plan.currency.toLowerCase());
        } else {
          Sentry.captureException('Error fetching plans');
          setError('No suitable plan found');
        }
      })
      .catch(error => {
        setError(error);
        Sentry.captureException(error);
      })
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const pageParam = queryParams.get('step');
    const submitParam = queryParams.get('submit');

    if(submitParam && submitParam == "1") {
      localStorage.setItem('tf_submit', 1);
    }

    // Show banner only on step 4
    if(pageParam === 'plans') {
      document.getElementById('top_banner').style.display = 'block';
    } else {
      document.getElementById('top_banner').style.display = 'none';
    }

    // Show Intercom only on step 5
    if(pageParam === 'checkout') {
      let sheets = document.styleSheets;
      for (let i = 0; i < sheets.length; i++) {
          try {
              let rules = sheets[i].cssRules || sheets[i].rules;
              for (let j = 0; j < rules.length; j++) {
                  if (rules[j].selectorText && rules[j].selectorText.includes(".intercom-lightweight-app, .intercom-namespace")) {
                      sheets[i].deleteRule(j);
                  }
              }
          } catch (e) {
              console.warn("Cannot access stylesheet:", e);
          }
      }
    }

    if (pageParam) {
      setPage(pageParam);
      localStorage.setItem('step_visited', page);
    }
  }, [location.search])

  const goToMembership = () => {
    var membershipSection = document.getElementById('membership');
    if (membershipSection) {
      membershipSection.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const updatePage = (newPage) => {
    history.push({ search: '?step=' + newPage });
    localStorage.setItem('step_visited', newPage);
  };

  const nextPage = async() => {

    if(page == 'email' && email.trim()){
      if (!/^\S+@\S+\.\S+$/.test(email)) {
        setEmailError('Enter a valid email address');
        console.log("INVALID EMAIL");
        return;
      }
      else{
        try {

          // if(signupTriggered) return;

          setEmailError(null);
          localStorage.setItem('email',email);
          set_cookie('email',email,7)

          let tf_uuid = localStorage.getItem('typeform_uuid');
          let userSub = await sendSignUpEvent(email, '', tf_uuid); 
          setUserSubExists(!userSub);

          //Send signup event to VWO
          const VWO = window.VWO;
          VWO.event("signup", {
            "email": email
          });

          window.dataLayer.push({
            event: 'gtm4wp.userRegistered',
            email: email,
            signup_type: 'email',
            visitorEmail: email
          });

          // localStorage.setItem('tracked_email', email);

          if (typeof window.Cookiebot !== 'undefined') {
            window.Cookiebot.submitCustomConsent(true, true, true);
            window.Cookiebot.hide()
          }
          setSignupTriggered(true);


        } catch (error) {
          console.log("userRegistered error: ",error);
          Sentry.captureException('userRegistered error: ', error);
        }
      }
    }

    if(page == 'plans') {
      const email = localStorage.getItem('email');

      if (email) {
        updateKlaviyoProfile(email, {
          'Cart - Plan': selectedPlan.display_name,
          'Cart - Currency': selectedPlan.currency,
          'Cart - Value': selectedPlan.discounted_price ?? selectedPlan.price
        })
        .catch(error => Sentry.captureException(error));
      }
  
      // Trigger add to cart event when the user clicks on continue
      window.dataLayer.push({
        event: 'add_to_cart',
        currency: selectedPlan.currency,
        value: selectedPlan.discounted_price ?? selectedPlan.price,
        items: [
          {
            item_id: selectedPlan.product_sku,
            item_name: selectedPlan.display_name,
            price: selectedPlan.discounted_price ?? selectedPlan.price,
            quantity: 1
          }
        ]
      });
    }

    updatePage(getNextStep(page));
  }

  useEffect(() => {
    if (page == 'checkout') {
      boot();
    }
    else {
      shutdown();
    }

    if (page == 'email') {
      let cookieEmail = get_cookie("email");
      if(cookieEmail){
            //Send signup data to zap
            localStorage.setItem('email',cookieEmail);
            let tf_uuid = localStorage.getItem('typeform_uuid');
            if(tf_uuid && !get_cookie("tf_uuid")){
              set_cookie('tf_uuid',tf_uuid);
              sendSignupToZapier(tf_uuid, cookieEmail);

              if (typeof window.Cookiebot !== 'undefined') {
                window.Cookiebot.submitCustomConsent(true, true, true);
                window.Cookiebot.hide()
              }
            }
  
            updatePage(getNextStep(page));
      }
    }

    if (page == 'plans') {
      localStorage.setItem('plans_visited', true);
      const email = localStorage.getItem('email');
      if (email && !get_cookie('plans_page_view')) {
        updateKlaviyoProfile(email, {
           'Plans - Page View': true
        })
        .then(() => set_cookie('plans_page_view', 'true', 7))
        .catch(error => Sentry.captureException(error));
      }
    }

    if (page == 'checkout') {

      const email = localStorage.getItem('email');
      if (email && !get_cookie('checkout_page_view')) {
          updateKlaviyoProfile(email, {
            'Checkout - Page View': true
          })
          .then(() => set_cookie('checkout_page_view', 'true', 7))
          .catch(error => Sentry.captureException(error));
      }
    }

    // Trigger page_view event
    try {
      let pageTitle = '';
      switch (page) {
        case 'quiz':
          pageTitle = 'memberships/typeform';
          break;
        case 'email':
          pageTitle = 'memberships/email';
          break;
        case 'start-cooking':
          pageTitle = 'memberships/overview';
          break;
        case 'plans':
          pageTitle = 'memberships/plans';
          break;
        case 'checkout':
          pageTitle = 'memberships/checkout';
          break;
        default:
          pageTitle = 'memberships';
          break;
      }

      window.dataLayer.push({
        event: 'page_view',
        page_title: pageTitle,
        page_location: window.location.href,
        page_path: window.location.pathname
      });

    } catch (error) {
      Sentry.captureException("page_view event trigger error: ", error);
    }
  }, [page])

  return (
    <>{processingOrder ? <FullLoader /> : null}
      <section className="headerSection" data-page={page}>
        <a class="yc_logo" href="/">YES<b>CHEF</b></a>
        {page <= 3 && <a href='?step=4'><button class="btn_get_yeschef" type="button">BUY YESCHEF</button></a>}
      </section>
      <section className="joSpecialSection" data-visible={get_cookie('utm_platform') === 'joc'} data-page={page}>
        <div>Limited time: 50% off for Jamie fans with code&nbsp;<b>JO50</b></div>
      </section>
      <div className={`App ${page === 'quiz' || page === 'checkout' ? 'no-margin' : ''}`} style={{ display: processingOrder ? 'none' : 'block' }}>
        {page == 'quiz' && (<section className={styles.typeformSection}>
          <TypeformComponent />
        </section>)}
        {page == 'email' && (<section className={styles.emailSection}>
          <div className={`${styles.emailInputContainer}`}><div className={styles.emailInput}>
            {/* <label className={styles.inputLabel}>Email Address</label> */}
            <h1 className={styles.emailSectionHeading}>Begin your culinary journey</h1>
            <h2 className={styles.emailSectionSubHeading}>Enter your email to get started</h2>
            <input
              type="text"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                // clearTimeout(validateTimeout);
                // if (checkErrors) validateTimeout = setTimeout(() => validateFields(), 800);
              }}
              placeholder="Your email address"
              // className={`${styles.inputField} ${errors.email ? styles.inputError : ''}`} 
              />
            {emailError && <div className={styles.errorMsg}>{emailError}</div>}
          </div></div>
        </section>)}
        {page == 'thinking' && <ThinkingSection />}
        {page == 'start-cooking' && (<section className="promotions-section">
          <h1 className="promotionsTitle__desktop">Start cooking better today</h1>
          <h1 className="promotionsTitle__mobile">Start cooking better today</h1>
          <div className='promotions-container' onClick={() => goToMembership()}>
            {promotions.map(promotion => (
              <Promotion
                key={promotion.id}
                image={promotion.image}
                header={promotion.header}
                description={promotion.description}
              />
            ))}
          </div>
        </section>)}
        {/* {loading && <Loader/>} */}
        {error && <div>Error fetching plans: {error}</div>}
        {page == 'plans' && (<section id="membership" className="plans-section">
          <h1>Choose your membership</h1>
          <p className={styles.choosePlanDescription}>Unlock access to a growing library of immersive 4k video classes with the world's best chefs, including:</p>
          <div className={styles.membershipBenefitsList}>
            <div className={styles.membershipBenefitsListItem}><Checkmark /><span>Step-by-step guided lessons</span></div>
            <div className={styles.membershipBenefitsListItem}><Checkmark /><span>PDF recipe books</span></div>
            <div className={styles.membershipBenefitsListItem}><Checkmark /><span>Access on up to 5 devices</span></div>
          </div>
          {/* {specialOffer && <div className={styles.specialOffer}>{specialOffer}</div>} */}
          <div className="plans-container">
          {plans.filter((plan) => !plan.hidden).map((plan) => {
            const annualPlan = plans.filter((plan) => plan.subscription_period === 'annual')?.[0];

            return (
              <Plan
                key={plan.product_id}
                product_sku={plan.product_id}
                title={plan.title}
                displayName={plan.display_name}
                price={plan.price}
                bogo={plan.bogo}
                discounted_price={plan.discounted_price}
                subscription_period={plan.subscription_period}
                showSavings={plan.showSavings}
                planOfferText={plan.plan_offer_text}
                planUpgradeText={plan.plan_upgrade_text}
                savingAmount={plan.saving_amount}
                isPopular={plan.subscription_period === 'annual'}
                planInfo={plan.planInfo}
                discountToAnnual={annualPlan ? Number(plan?.discounted_price ?? plan?.price)*12/Number(plan.duration_months) - Number(annualPlan?.discounted_price ?? annualPlan?.price): 0}
                show_monthly_price={plan.show_monthly_price}
                currency_symbol={plan.currency_symbol}
                duration_months={parseInt(plan.duration_months)}
                selected={selectedPlanSku === plan.product_id}
                onClick={() => selectPlan(plan)}
              />
            );
          })}
          </div>
          <div className={styles.MoneyBackGuarantee}>
            <div className={styles.Includes}>All Plans include</div>
            <div className={styles.ThirtyDaysMoneyBack}>30-Day Money-Back Guarantee</div>
          </div>
          </section>)}
        {page == 'checkout' && (<section className={styles.paymentSection}>
          <Elements stripe={stripePromise} options={elementOptions}>
            <PaymentForm
              cart={cart}
              setCart={setCart}
              selectedPlan={selectedPlan}
              loading={loading}
              setLoading={setLoading}
              currency_symbol={currencySymbol}
              showSkeleton={showSkeleton}
              setShowSkeleton={setShowSkeleton}
              setProcessingOrder={setProcessingOrder}
              initCart={initCart}
              signupEmailStep={signupTriggered}
              userSubExists={userSubExists}
            />
          </Elements>
        </section>)}
        {page == 'checkout' && (<section className={styles.guaranteeSection}>
          <div className={styles.guaranteeContainer}>
            <div className={styles.guaranteeImg}><img src="/wp-content/reactpress/apps/yc-checkout/build/assets/shield.webp" alt="Checkmark" className={styles.shieldImg} /></div>
            <div>
              <h4>100% money-back guarantee</h4>
              <p>If you’re not 100% satisfied within 30 days, you’ll get all your money back.</p>
            </div>
          </div>
        </section>)}
        {page !== 'quiz' && page !== 'checkout' && page !== 'thinking' && (<section className={styles.paginationSection}>
          {/* {page > 1 && (
            <button className={styles.previousButton} onClick={previousPage}>
              Previous
            </button>
          )} */}
          {page !== 'checkout' && (<button className={styles.nextButton} onClick={nextPage}>
            Continue
          </button>)}

        </section>)}
        {page == 'email' && <p className={styles.emailSectionDescription}>By continuing you accept our <u><a href="https://yeschef.me/terms" className={styles.link}>Terms</a></u> and <u><a href="https://yeschef.me/privacy" className={styles.link}>Privacy Policy</a></u>.</p>}

      </div>
    </>
  );
}

export default App;